// Responsive column height shared by the center card and side panels.
// Bounded by design max (700px), viewport height, and viewport width.
export const COLUMN_HEIGHT =
  "min(700px, calc(100vh - 96px), calc((100vw - 128px) * 569 / 1104))";

export const PERKS_QUIRKS_XP = 10;
export const JOB_GEAR_XP = 5;
export const HIGH_SCHOOL_PRIORITIES_XP = 10;
export const AFTER_HIGH_SCHOOL_XP = 10;

export const ACTIVITY_IDS = {
  perksQuirks: (hatId: string) => `perksquirks-${hatId}`,
  jobGear: (hatId: string) => `jobgear-${hatId}`,
  highSchoolPriorities: (hatId: string) => `highschoolpriorities-${hatId}`,
  afterHighSchool: (hatId: string) => `afterhighschool-${hatId}`,
} as const;
